import { render, staticRenderFns } from "./external-links-user-teams.vue?vue&type=template&id=1c3369aa&scoped=true&"
import script from "./external-links-user-teams.ts?vue&type=script&lang=ts&"
export * from "./external-links-user-teams.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.1_cache-loader@4.1.0_webpack@4.44.2__css-loader@3.5.2_webpack@4.44.2__lodash@_woylw74pnr2dauffvwh757gxea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3369aa",
  null
  
)

export default component.exports